import { render, staticRenderFns } from "./OthOutList.vue?vue&type=template&id=a65752fa"
import script from "./OthOutList.vue?vue&type=script&lang=js"
export * from "./OthOutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports